export const dataTypes = {
    pharmacogenomics: 'pset',
    toxicogenomics: 'toxicoset',
    xenographic: 'xevaset',
    clinicalgenomics: 'clinicalgenomics',
    radiogenomics: 'radioset',
    radiomics: 'radiomicset',
    icb: 'clinical_icb'
};
